<template>
  <StatusBadge
    v-if="resourceStatus"
    :class="$style.statusBadge"
    :status="resourceStatus.indicator"
    :text="resourceStatus.label"
  />
</template>

<script>
import { get } from 'lodash';
import { mapState } from 'vuex';

import { StatusBadge } from '@jumpcloud/ui-components';

const statusConfig = {
  allow: {
    indicator: 'success',
    label: 'Allow Authentication',
  },
  allowwithmfa: {
    indicator: 'success',
    label: 'Allow Authentication & Require MFA',
  },
  deny: {
    indicator: 'error',
    label: 'Deny Access',
  },
  legacy: {
    indicator: 'success',
    label: 'Require MFA based on user setting',
  },
  unknown: {
    indicator: 'inactive',
    label: 'Status Unavailable',
  },
};

export default {
  name: 'GlobalPolicyStatusBadge',

  components: {
    StatusBadge,
  },

  props: {
    stateName: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState({
      resourceItem(state) {
        return state[this.stateName].item;
      },
    }),

    resourceStatus() {
      const action = get(this.resourceItem, 'effect.action', 'unknown');
      return statusConfig[action];
    },
  },

  created() {
    this.fetchItem();
  },

  methods: {
    fetchItem() {
      return this.$store.dispatch(`${this.stateName}/fetchItem`);
    },
  },
};
</script>

<style scoped module>
  .statusBadge {
    margin-left: 1em;
  }
</style>
